/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { areaHead } from "../../../../../config/constant";
import { Image, Space } from "antd";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, Box, TextField, TableRow, TableCell } from "@mui/material";
import clsx from "clsx";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { emptyValidation } from "../../../../../helpers/validation";
import { NavLink } from "react-router-dom";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import usePrevious from "../../../../Shared/components/Previous";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const AreaTable = (props) => {
    const { cityDetails, details, pincodeDetails, countryDetails,
        stateDetails, onRequestSort, sortOrder, sortBy, loadTasks, changeStateApi,
        loadMore, loadMoreContent, loadMoreTask, customObject, roleManagement } = props

    const [visible, setVisible] = useState(false);
    const [areaId, setAreaId] = useState('');
    const [pincodeArea, setPincodeArea] = useState('');
    const [pincodeId, setPincodeId] = useState('');
    const [cityId, setCityId] = useState('');
    const [stateId, setStateId] = useState('');
    const [countryId, setCountryId] = useState('');
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [deleteModal, setDeleteModal] = useState(false);

    const [errorAreaName, setErrorAreaName] = useState(false);
    const [errorPincodeId, setErrorPincodeId] = useState(false);
    const [errorCityId, setErrorCityId] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const onEdit = (data) => {
        setVisible(true);
        setAreaId(data.id);
        changeStateApi(data.stateId);
        setCityId(data?.cityId);
        setStateId(data.stateId);
        setCountryId(data.countryId);
        setPincodeId(data.pincodeId);
        setPincodeArea(data.name);
    }

    const emptyState = () => {
        setErrorAreaName(false)
        setErrorCityId(false);
    }

    const emptyStateInput = () => {
        setPincodeArea('');
        setPincodeId('');
        setCityId('');
        setStateId('');
        setCountryId('');
    }

    const dispatch = useDispatch();
    const editPincode = (e) => {
        e.preventDefault();
        let emptyAreaName = emptyValidation('Area Name', pincodeArea);
        let emptyCityId = emptyValidation('City', cityId, 'dropDown');
        let emptyPincodeId = emptyValidation('Pincode', pincodeId, 'dropDown');
        emptyState();
        if (emptyAreaName.isValid && emptyCityId.isValid && emptyPincodeId.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'area',
                title: "Area",
                id: areaId,
                details: {
                    name: pincodeArea,
                    pincodeId: pincodeId,
                    cityId: cityId,
                    stateId: stateId,
                    countryId: countryId
                }
            });
        } else {
            if (emptyAreaName.errors !== '') {
                setErrorAreaName(emptyAreaName.errors);
            } if (emptyCityId.errors !== '') {
                setErrorCityId(emptyCityId.errors);
            }
            if (emptyPincodeId.errors !== '') {
                setErrorPincodeId(emptyPincodeId.errors);
            }
        }
    }


    const changeCity = (value) => {
        setCityId(value);
        let a = cityDetails && cityDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setStateId(a[0].stateId);
            setCountryId(a[0].countryId);
        }
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            emptyStateInput();
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setErrorAreaName(error);
        }
    }, [editDetails, editError]);


    const onDelete = (data) => {
        setDeleteModal(true);
        setAreaId(data.id);
        setPincodeArea(data.name);
    }

    const changePincode = (value) => {
        setPincodeId(value);
        let a = pincodeDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            setStateId(a[0].stateId);
            setCountryId(a[0].countryId);
        }
    }

    const changeState = (value) => {
        setPincodeId('');
        setCityId('');
        let a = stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
        }
        changeStateApi(value);
        setStateId(value)
    }

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={areaHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(areaHead, 0) }}><span style={{ width: getColumnWidth(areaHead, 0) }}>{data.name}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(areaHead, 1) }}><span style={{ width: getColumnWidth(areaHead, 1) }}>{data.pincode ? data.pincode.code : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(areaHead, 2) }}><span style={{ width: getColumnWidth(areaHead, 2) }}>{data.city ? data.city.name : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(areaHead, 3) }}><span style={{ width: getColumnWidth(areaHead, 3) }}>{data.state ? data.state.name : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(areaHead, 4) }}><span style={{ width: getColumnWidth(areaHead, 4) }}>{data.country ? data.country.name : '---'}</span></TableCell>
                                                <TableCell scope="row" className={clsx(classes.tableLastColumn)}>
                                                    {
                                                        <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                            {
                                                                roleManagement !== '' && (checkCRUDPermission('Area', 'edit', 'Younote Admin') || checkCRUDPermission('Area', 'edit', 'Admin')) &&
                                                                <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                    <Image
                                                                        src={EditIcon}
                                                                        preview={false}
                                                                    />
                                                                </NavLink>
                                                            }
                                                            {
                                                                roleManagement !== '' && (checkCRUDPermission('Area', 'deletable', 'Younote Admin') || checkCRUDPermission('Area', 'deletable', 'Admin')) &&
                                                                <NavLink to={"#"} onClick={() => onDelete(data)}>
                                                                    <Image
                                                                        src={DeleteIcon}
                                                                        preview={false}
                                                                    />
                                                                </NavLink>
                                                            }
                                                        </Space>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Area'}</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Area'}
                width={"360px"}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editPincode(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Area Name ", <span key={"Area Name"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={errorAreaName ? true : false}
                                helperText={errorAreaName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setPincodeArea(e.target.value)}
                                value={pincodeArea}
                            />
                            <AutoCompleteComponent
                                name={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'code', 'name': 'Pincode' },
                                { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                details={pincodeDetails}
                                parentValue={customObject(pincodeDetails, pincodeId)}
                                onChange={(data) => changePincode(data.id)}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                                parentError={errorPincodeId}
                            />
                            <AutoCompleteComponent
                                name={["Dist/City/Town ", <span key={"Dist/City/Town"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Name' },
                                { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                details={cityDetails}
                                parentValue={customObject(cityDetails, cityId)}
                                onChange={(data) => changeCity(data.id)}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                                parentError={errorCityId}
                            />
                            <AutoCompleteComponent
                                name={["State"]}
                                heads={[{ 'key': 'name', 'name': 'State Name' },
                                { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                details={stateDetails}
                                parentValue={customObject(stateDetails, stateId)}
                                onChange={(data) => { changeState(data.id) }}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                            />
                            <AutoCompleteComponent
                                name={["Country"]}
                                heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                details={countryDetails}
                                parentValue={customObject(countryDetails, countryId)}
                                onChange={(data) => setCountryId(data.id)}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            >
                                Update & Save
                            </Button>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={areaId} loadTasks={() => loadTasks()} name={pincodeArea} url={'area'} title={'Area'} visible={deleteModal} />
        </>
    );
}